<template>
  <div
    v-if="isLowAvailability"
    data-testid="pdp-lowstock-message"
    class="error-color medium margin-bottom-m"
  >
    Low Stock
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useUpc } from '@common-vue/media-card-large';

const props = defineProps({
  productId: {
    type: String,
    required: true,
  },
});

const { upcData, selectedUpcId } = useUpc(props.productId);
const currentUpcData = computed(() => upcData.value.upcs[selectedUpcId.value] || null);
const isLowAvailability = computed(() => currentUpcData.value?.availability?.lowAvailability || false);

defineExpose({ // eslint-disable-line no-undef
  upcData,
  selectedUpcId,
  currentUpcData,
  isLowAvailability,
});
</script>
